import { render, staticRenderFns } from "./LabelMatch.vue?vue&type=template&id=53b46e20"
import script from "./LabelMatch.vue?vue&type=script&lang=js"
export * from "./LabelMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports